import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeVegan: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.13755 2.63409C2.29784 2.50295 2.5341 2.52657 2.66525 2.68686C6.30809 7.13923 7.57308 11.4738 7.74795 13.1351C7.76963 13.341 7.62024 13.5256 7.41427 13.5473C7.2083 13.5689 7.02375 13.4196 7.00207 13.2136C6.84361 11.7082 5.64193 7.50942 2.08478 3.16179C1.95363 3.0015 1.97726 2.76524 2.13755 2.63409ZM13.5881 2.61575C13.6768 2.677 13.7348 2.77346 13.7474 2.88051C13.9522 4.62136 13.7195 5.74441 13.2733 6.43425C12.8176 7.13868 12.16 7.3549 11.6546 7.29688C11.4488 7.27326 11.3012 7.08731 11.3248 6.88156C11.3484 6.6758 11.5344 6.52815 11.7401 6.55177C11.9606 6.57709 12.3418 6.49331 12.6435 6.0269C12.9268 5.58894 13.1537 4.78815 13.0447 3.39585C12.024 3.66362 11.1877 3.93951 10.6551 4.30285C10.3613 4.50332 10.1945 4.70799 10.1237 4.92026C10.0547 5.12729 10.0579 5.39915 10.2197 5.77661C10.3013 5.96697 10.2131 6.18742 10.0227 6.26901C9.83237 6.35059 9.61192 6.26241 9.53033 6.07205C9.3171 5.57451 9.2703 5.10887 9.41222 4.68309C9.55241 4.26254 9.85751 3.93909 10.2324 3.6833C10.9658 3.18298 12.0957 2.85762 13.2841 2.56052C13.3886 2.53438 13.4994 2.5545 13.5881 2.61575ZM3.60985 2.65916C3.75629 2.51272 3.99373 2.51272 4.14018 2.65916C6.75201 5.271 8.04964 8.26201 8.6189 10.5233C9.18769 8.39712 10.3252 6.4263 11.3939 4.95404C11.5405 4.7521 11.6862 4.55896 11.8295 4.37547C11.9569 4.21224 12.1926 4.18325 12.3558 4.31073C12.5191 4.4382 12.548 4.67386 12.4206 4.83709C12.2826 5.01376 12.1422 5.19988 12.0008 5.39461C10.529 7.42228 9.00001 10.3221 9.00001 13.1743C9.00001 13.3814 8.83212 13.5493 8.62501 13.5493C8.41791 13.5493 8.25001 13.3814 8.25001 13.1743C8.25001 11.4256 7.32968 6.90932 3.60985 3.18949C3.4634 3.04305 3.4634 2.80561 3.60985 2.65916Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeVegan;
